import React, {Component} from "react";
import {fetchContent, fetchAndParseContent} from "../contenful/ContentfulActions";
import FooterComponent from "./FooterComponent";
import {connect} from "react-redux";
import {ContentModelName, FooterPayload, GlobalPayload} from "../contenful/types";
import {AppState} from "../RootReducer";
import {Dispatch} from "redux";
import {Spinner} from "../ui/Spinner";
import {withRouter} from "react-router";
import {RouteComponentProps} from "react-router-dom";
import {LoginStatus} from "../http/Types";
import {getContainer} from "../ioc/IOCSetup";
import { AppContext, MenuPosition } from "../http/protocol";



type AllProps = PropsFromState & PropsFromDispatch & OtherProps;

export class Footer extends Component<AllProps> {
    constructor(props: AllProps) {
        super(props);
    }
    componentDidMount(): void {
        if(!this.props.isFetching) {
            if(this.props.error == undefined) {
                if(this.props.footer === undefined) {
                    this.props.fetchContent(ContentModelName.FOOTER, this.props.lng);
                }
            }
        }
    }



    handleClick = (nameId: string) => {
        this.props.history.push(`/info/${nameId}`);
    }

    render() {
        return (
            <React.Fragment>
                {
                    this.props.isFetching
                        ? <Spinner/>
                        : this.props.footer ? (<FooterComponent appContext={this.props.appContext} position={this.props.position} loggedIn={this.props.loggedIn} windowSize={this.props.windowSize} onClick={this.handleClick} footer={this.props.footer}/>) : null
                }
            </React.Fragment>
        )
    }

}

interface OtherProps extends RouteComponentProps {
}

interface PropsFromState {
    isFetching?: boolean;
    footer?: FooterPayload;
    error?: string;
    global?:GlobalPayload;
    windowSize: number;
    loggedIn : boolean;
    lng: string;
    position?: MenuPosition
    appContext?: AppContext;
}

interface PropsFromDispatch {
    fetchContent: typeof fetchContent;
}


const mapStateToProps = ({contentful, settings, user} : AppState) => {
    return {
        isFetching: contentful.isFetchingMultiple,
        error: contentful.error,
        footer: contentful.footer,
        windowSize: settings.windowSize,
        loggedIn : LoginStatus.LOGGED_IN == user.status,
        lng: getContainer().getSettingsService().getActiveLocale().code,
        position: settings.settings?.menu?.settings?.position,
        appContext: settings.appContext
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        fetchContent: (contentModelName: ContentModelName, locale?: string) => dispatch(fetchAndParseContent(contentModelName, locale) as any)
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(withRouter<AllProps,any>(Footer))